var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "my-quota-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("walletQuota.myQuota")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.txNum || 0) + " UT")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }